module.exports = __webpack_public_path__ + "static/media/shovel-snow.ff348899.svg";